import { render, staticRenderFns } from "./jieshununlicensed.vue?vue&type=template&id=1495dba0&scoped=true"
import script from "./jieshununlicensed.vue?vue&type=script&lang=js"
export * from "./jieshununlicensed.vue?vue&type=script&lang=js"
import style0 from "./jieshununlicensed.vue?vue&type=style&index=0&id=1495dba0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1495dba0",
  null
  
)

export default component.exports